import React from 'react';

import { useUiComponentsInternationalContext } from '@repo/static-translations';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../shadcn/Accordion';
import { Checkbox } from '../../shadcn/Checkbox';
import { Label } from '../../shadcn/Label';

type FiltersType = {
  active: boolean;
  tag: string;
  title: string;
};

interface Props {
  activeFilters: {
    filters: FiltersType[];
    group: string;
    groupTitle: string;
  }[];
  handleFilters: (arg: {
    checked: boolean;
    filter: FiltersType;
    group: string;
  }) => void;
}

const CollectionFilters = ({
  activeFilters = [],
  handleFilters,
}: Readonly<Props>) => {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Accordion
      className="w-full"
      defaultValue={activeFilters.map((_, ix) => ix.toString())}
      type="multiple"
    >
      {activeFilters.map(({ group, groupTitle, filters }, index) => (
        <AccordionItem
          className="border-b"
          key={group}
          value={index.toString()}
        >
          <fieldset>
            <legend className="text-base w-full">
              <AccordionTrigger
                aria-label={tt(
                  s => s.blocksDeptComponents.filterByGroupAriaLabel,
                  { group }
                )}
                className="flex justify-between items-center flex-1 px-1 py-3 hover:bg-accent hover:no-underline font-bold text-foreground"
              >
                {groupTitle}
              </AccordionTrigger>
            </legend>
            <AccordionContent>
              <div
                aria-labelledby={`filter-group-${index}`}
                className="flex flex-col gap-2 p-2"
                role="group"
              >
                {filters.map(filter => (
                  <div className="items-top flex space-x-2" key={filter.title}>
                    <Checkbox
                      checked={filter.active}
                      id={filter.title}
                      onCheckedChange={checked =>
                        handleFilters({ checked: !!checked, filter, group })
                      }
                    />
                    <Label
                      className="text-sm font-light text-foreground"
                      htmlFor={filter.title}
                    >
                      {filter.title}
                    </Label>
                  </div>
                ))}
              </div>
            </AccordionContent>
          </fieldset>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default CollectionFilters;
